package com.patronat.top.features.dashboard.domain.usecase.command

import com.patronat.top.domain.usecase.Command

class GetDashboardStatsCommand : Command
